import styled from "styled-components";

export const CardItens = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  justify-content: center;
  align-items: center;
  background: rgba(255,255,255,0.78); 
  width:  70px;
  height: 70px;
  border-radius: 10px;
  margin-left: ${props => props.left && '7px'};
  div{
  margin-top: 5px;
  }
  p{
  margin-top: 5px;

  font-size: 7px;
  }       
`;


export const CollHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 40%; 
  color: black;
  p{
    margin-top: 10px;
    font-size: 0.8rem;
    color: white;    
  }
  h2{
     color: white;  
     font-size: 6vw;
      margin: 0;
      margin-top: 4px;
   }
`;